/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 11.07.2016
 *
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { ListGroupItem } from 'external/react-bootstrap';

class MapConfigCopyItem extends React.Component {

    onClick(e) {
        this.props.onClick(this.props.item, e);
    }

    render() {

        const dataItem = this.props.item,
            item = dataItem && (dataItem.item || dataItem);

        return (
            <ListGroupItem {...this.props} onClick={this.onClick.bind(this)}>

                {item.title + ' - (' + item.description + ')'}

            </ListGroupItem>
        );
    }
}

MapConfigCopyItem.propTypes = {
    ...ListGroupItem.propTypes,
    item: PropTypes.object.isRequired,
    onClick: PropTypes.func
};

export default MapConfigCopyItem;


// WEBPACK FOOTER //
// ./js/components/MapConfigCopyItem.jsx